export const LOCAL_STORAGE_TOKEN = "token";
export const LOCAL_STORAGE_REFRESH_TOKEN = "refresh_token";
export const LOCAL_STORAGE_LOGGED_EMAIL = "logged_email";
export const LOCAL_STORAGE_LOGGED_USER_ID = "logged_user_id";
export const LOCAL_STORAGE_INFO_PLANT_USER = "info_plant_user";
export const LOCAL_STORAGE_CURRENT_LANG = "current_lang";

